import moment from 'moment';

/**
 * Format a date as e.g. "Jul 11, 2026". Returns "—" when the value is missing
 * or unparseable.
 *
 * The guard matters more than it looks: `moment(undefined)` returns NOW, so a
 * field the API didn't send silently rendered as TODAY'S DATE. That is worse
 * than a blank — it presents invented data as fact. It showed every producer's
 * subscription as "Purchased on <today>" while ending in 2023. `moment(null)`
 * renders the literal string "Invalid date", which is just as unhelpful to an
 * operator. Both now render an em dash.
 */
export const dateFormat = (date) => {
  if (!date) return '—';
  const d = moment(date);
  return d.isValid() ? d.format('ll') : '—';
}

/** Format a time as e.g. "2:30 PM". Returns "—" for missing/invalid values. */
export const timeFormat = (date) => {
  if (!date) return '—';
  const d = moment(date);
  // 12-hour clock with the meridiem — `HH:mm A` printed a 24-hour hour next to
  // an AM/PM suffix ("14:17 PM"). `h:mm A` is the intended format.
  return d.isValid() ? d.format('h:mm A') : '—';
}
